<section class="w-full h-screen flex flex-col items-center justify-center bg-d1">
  <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 select-none">
      <div class="mx-auto max-w-screen-sm text-center">
        <h1 class="mb-4 text-7xl tracking-tight font-bold lg:text-9xl text-d4">404</h1>
          <p class="mb-4 text-lg font-light text-gray-400">Whoops! That page doesn’t exist.</p>
      </div>   
  </div>
</section>